import type { CSSProperties } from 'react';
import { forwardRef } from 'react';
import { Layout } from '../../../types';
import { SideMediaContainer } from '../components';
import type { PlayerAPI } from './BaseVideoBlock';
import { BaseVideoBlock } from './BaseVideoBlock';
import type { VideoBlockProps } from './VideoBlock';

export const SideVideoBlock = forwardRef<PlayerAPI, VideoBlockProps>(
  (
    { src, layout, areaWidth, style, className, scale, ratio, borderRadius },
    forwardingRef
  ) => {
    const isBannerLayout = [Layout.LeftBanner, Layout.RightBanner].includes(
      layout
    );

    const mediaVideoStyle: CSSProperties = {
      height: 'auto',
      marginInline: 'auto'
    };

    const bannerVideoStyle: CSSProperties = {
      height: '100%',
      position: 'absolute',
      inset: 0
    };

    const videoBlockStyle = isBannerLayout ? bannerVideoStyle : mediaVideoStyle;

    return (
      <SideMediaContainer layout={layout} areaWidth={areaWidth}>
        <BaseVideoBlock
          ref={forwardingRef}
          className={className}
          src={src}
          scale={scale}
          ratio={ratio}
          borderRadius={borderRadius}
          style={{
            ...videoBlockStyle,
            ...style
          }}
        />
      </SideMediaContainer>
    );
  }
);
